import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import EventNoteIcon from '@mui/icons-material/EventNote';
import { useLocation } from 'react-router';
import Box from '@mui/material/Box';
import { CircularProgress } from '@mui/material';

import Alert, { useAlert } from 'components/snacks/Alert';

import { axiosInstance, getFactorDetail } from 'api/Api';
import { numSeperator } from 'utils/DataBase';
import Loading from 'layout/Loading';

const FactorDetail = () => {
  const location = useLocation();
  const [factorInfo, setFactorInfo] = useState({});
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloadLink, setDownloadLink] = useState('#');
  const [bankDetail, setBankDetail] = useState({
    card_number: '5892-1013-0981-0436',
    shaba_number: 'IR840150000003101003635941',
    owner_name: 'فاطمه بقائی فر',
    bank_name: 'بانک سپه'
  });
  const [modalDetail, setModalDetail] = useState({
    show: false,
    type: 1,
    loading: false
  });
  
  const alert_timeout = 10000;
  const alertStore = useAlert( alert_timeout );
  
  useEffect(() => {
    setLoading(true);
    getFactorDetail(location.state.id, (isOk, data) => {
      if (isOk) {
        setFactorInfo(data.factor_info);
        setDetails(data.details);
        setLoading(false);
        setBankDetail({
          card_number: data.card_no,
          shaba_number: data.shaba_no,
          owner_name: data.account_name,
          bank_name: data.account
        });
        setDownloadLink(
          `${data.download_link}?invoice_no=${
            data.factor_info.invoice_no
          }&token=${localStorage.getItem('token')}`
        );
      } else {
        setLoading(false);
        alertStore.AddAlert({
          key: '400',
          message: data,
          severity: 'error',
          auto_hide: true
        });
      }
    });
  }, []);

  const modalShower = () => {
    setModalDetail({
      show: true,
      type: factorInfo.payment_method,
      loading: false
    });
  };

  const copyText = (txt) => {
    navigator.clipboard.writeText( txt );
    alertStore.AddAlert({
      key: 'copy',
      message: 'با موفقیت کپی شد',
      severity: 'success',
      auto_hide: true
    });
  };

  const paymentFactor = () => {
    const formData = new FormData();
    formData.append('invoice_id', factorInfo.invoice_no);
    setModalDetail({ ...modalDetail, loading: true });
    axiosInstance()
      .post('/online-payment', formData)
      .then((r) => {
        if (r.data.status === 200) {
          return window.location.replace(r.data.url);
        } else {
          setModalDetail({ ...modalDetail, loading: false });
          alertStore.AddAlert({
            key: 'payment',
            message: r.data.msg,
            severity: 'error',
            auto_hide: true
          });
        }
      });
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <Paper className={'normal-shadow rounded bg-white'} elevation={1}>
            <div className="card-body p-lg-20">
              <div className="d-flex flex-column flex-xl-row">
                <div className="flex-lg-row-fluid me-xl-18 mb-10 mb-xl-0">
                  <div className="mt-n1">
                    <div className="d-flex flex-stack pb-5 border-bottom flex-lg-row flex-column align-items-lg-center align-items-start">
                      <div
                        className={
                          'd-flex justify-content-start align-items-center'
                        }
                      >
                        <EventNoteIcon color={'white'} className={'f-25'} />
                        <h1 className={'f-2'}>جزییات فاکتور</h1>
                        {factorInfo.status === '0' && (
                          <span
                            className={'badge badge-light-danger my-2 ms-3'}
                          >
                            پرداخت نشده
                          </span>
                        )}

                        {factorInfo.status === '1' && (
                          <span
                            className={'badge badge-light-success my-2 ms-3'}
                          >
                            پرداخت شده
                          </span>
                        )}
                        {factorInfo.status === '2' && (
                          <span className={'badge badge-light-primary my-2'}>
                            تحویل شده
                          </span>
                        )}
                        {factorInfo.status === '3' && (
                          <span
                            className={'badge badge-light-danger my-2 ms-3'}
                          >
                            لغو شده
                          </span>
                        )}
                        <h6 className={'fs-7 badge badge-light-primary'}></h6>
                      </div>
                      <div
                        className={
                          'd-flex justify-content-start align-items-center mt-lg-0 mt-4'
                        }
                      >
                        {factorInfo.status === '0' && (
                          <button
                            onClick={modalShower}
                            className={
                              'btn btn-success btn-sm yekan-font w-80px'
                            }
                          >
                            پرداخت
                          </button>
                        )}
                        <Link
                          to={`/factors/factor-print-${factorInfo.invoice_no}/`}
                          className="btn btn-sm btn-primary ms-4 w-80px"
                        >
                          پرینت
                        </Link>
                      </div>
                    </div>
                    <div className="mt-4">
                      <div className="fw-bolder fs-3 text-gray-800 mb-8">
                        <span>سرویس: </span>
                        <span className={'ms-2'}>
                          {factorInfo.service_name}
                        </span>
                      </div>
                      <div className="row g-5 mb-5">
                        <div className="col-6">
                          <span className="fw-bold fs-7 text-gray-600 mb-1">
                            تاریخ ایجاد فاکتور:
                          </span>
                          <span className="fw-bolder fs-6 text-gray-800 ms-2">
                            {factorInfo.invoice_date}
                          </span>
                        </div>
                        <div className="col-6">
                          <span className="fw-bold fs-7 text-gray-600 mb-1">
                            تاریخ پرداخت:{' '}
                          </span>
                          <span className="fw-bolder fs-6 text-gray-800 ">
                            <span className="pe-2">
                              {factorInfo.payment_date ? (
                                <span className={'ms-2'}>
                                  {factorInfo.payment_date}
                                </span>
                              ) : (
                                <span
                                  className={'badge badge-light-danger ms-2'}
                                >
                                  ثبت نشده است
                                </span>
                              )}
                            </span>
                          </span>
                        </div>
                      </div>
                      <div className="row g-5 mb-12">
                        <div className="col-6">
                          <span className="fw-bold fs-7 text-gray-600 mb-1">
                            {' '}
                            شماره رسمی فاکتور:
                          </span>
                          <span className="fw-bolder fs-6 text-gray-800">
                            {factorInfo.factor_no !== '0' ? (
                              <span className={'ms-2'}>
                                {factorInfo.factor_no}
                              </span>
                            ) : (
                              <span className={'badge badge-light-danger ms-2'}>
                                ندارد
                              </span>
                            )}
                          </span>
                        </div>
                        <div className="col-6">
                          <span className="fw-bold fs-7 text-gray-600 mb-1">
                            {' '}
                            شماره فاکتور:
                          </span>
                          <span className="fw-bolder fs-6 text-gray-800 ms-2">
                            {factorInfo.invoice_no}
                          </span>
                        </div>
                        <div className="col-6">
                          {/*<div className="fw-bold fs-7 text-gray-600 mb-1"></div>*/}
                          <span className="fw-bold fs-7 text-gray-600">
                            کد پیگیری:{' '}
                          </span>
                          <span className="fw-bold fs-7 text-gray-600">
                            {factorInfo.ref_id ? (
                              <span className={'ms-2'}>
                                {factorInfo.ref_id}
                              </span>
                            ) : (
                              <span className={'badge badge-light-danger ms-2'}>
                                ندارد
                              </span>
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <div className="border-bottom mb-9">
                          <div className={'row'}>
                            <div className={'col-lg-6 col-12'}>
                              <h3
                                className={
                                  'fs-4 f-bold d-flex justify-content-start align-items-center mb-4'
                                }
                              >
                                قیمت سرویس ها
                              </h3>
                              <ul className={'list-style-none'}>
                                {details.length !== 0 ? (
                                  details.map((detail, index) => (
                                    <li
                                      key={index}
                                      className={
                                        'd-flex justify-content-start align-items-center mb-2 flex-wrap'
                                      }
                                    >
                                      <i
                                        className={
                                          'fa fa-genderless fs-2 me-2 text-primary'
                                        }
                                      />
                                      <span>{detail.title} :</span>
                                      {detail.price === '0' ? (
                                        <span
                                          className={
                                            'badge badge-light-success ms-2'
                                          }
                                        >
                                          رایگان
                                        </span>
                                      ) : (
                                        <span>{detail.price}</span>
                                      )}
                                    </li>
                                  ))
                                ) : (
                                  <span
                                    className={'badge badge-light-danger ms-n8'}
                                  >
                                    سرویسی وجود ندارد
                                  </span>
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end">
                          <div className="mw-300px">
                            <div className="d-flex flex-stack mb-3">
                              <div className="fw-bold pe-10 text-gray-600 fs-7">
                                مبلغ فاکتور:
                              </div>
                              <div className="text-end fw-bolder fs-6 text-gray-800">
                                {factorInfo.factor_price ? (
                                  <span className={'fs-7 ms-2'}>
                                    {numSeperator(factorInfo.factor_price)}{' '}
                                    &nbsp;تومان
                                  </span>
                                ) : (
                                  <span
                                    className={'badge badge-light-danger ms-n8'}
                                  >
                                    ندارد
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="d-flex flex-stack mb-3">
                              <div className="fw-bold pe-10 text-gray-600 fs-7">
                                مالیات:
                              </div>
                              <div className="text-end fw-bolder fs-6 text-gray-800">
                                {factorInfo.tax ? (
                                  <span className={'fs-7 ms-2'}>
                                    {numSeperator(factorInfo.tax)} &nbsp;تومان
                                  </span>
                                ) : (
                                  <span
                                    className={'badge badge-light-danger ms-n8'}
                                  >
                                    ندارد
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="d-flex flex-stack mb-3">
                              <div className="fw-bold pe-10 text-gray-600 fs-7">
                                تخفیف:
                              </div>
                              <div className="text-end fw-bolder fs-6 text-gray-800">
                                {factorInfo.discount ? (
                                  <span className={'fs-7 ms-2'}>
                                    {numSeperator(factorInfo.discount)} &nbsp;
                                    تومان
                                  </span>
                                ) : (
                                  <span
                                    className={'badge badge-light-danger ms-n8'}
                                  >
                                    ندارد
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="d-flex flex-stack mb-3">
                              <div className="fw-bold pe-10 text-gray-600 fs-7">
                                قابل پرداخت:
                              </div>
                              <div className="text-end fw-bolder fs-6 text-gray-800">
                                {factorInfo.total_payment ? (
                                  <span className={'fs-7 ms-2'}>
                                    {numSeperator(factorInfo.total_payment)}
                                    &nbsp; تومان
                                  </span>
                                ) : (
                                  <span
                                    className={'badge badge-light-danger ms-n8'}
                                  >
                                    ندارد
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="d-flex flex-stack">
                              <div className="fw-bold pe-10 text-gray-600 fs-7">
                                باقیمانده:
                              </div>
                              <div className="text-end fw-bolder fs-6 text-gray-800">
                                {factorInfo.remain ? (
                                  <span className={'fs-7 ms-2'}>
                                    {numSeperator(factorInfo.remain)}&nbsp;
                                    تومان
                                  </span>
                                ) : (
                                  <span
                                    className={'badge badge-light-danger ms-n8'}
                                  >
                                    ندارد
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Paper>
          {/* ******************* MODAL ***************************** */}
          {modalDetail.show && (
            <>
              <div className="modal fade show d-block" id="transferModal">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h1 className="modal-title fs-5" id="exampleModalLabel">
                        {modalDetail.title}
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() =>
                          setModalDetail({
                            ...modalDetail,
                            show: false
                          })
                        }
                      ></button>
                    </div>
                    {modalDetail.loading ? (
                      <>
                        <div className="modal-body text-center">
                          <Box
                            sx={{ display: 'flex', marginLeft: '15px' }}
                            className={'mx-auto'}
                          >
                            <CircularProgress className={'mx-auto'} />
                          </Box>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="modal-body">
                          {modalDetail.type === 1 ? (
                            <>
                              <div className="text-center">
                                <h5 className={'badge badge-primary w-100'}>
                                  شماره کارت
                                </h5>
                                <div
                                  className={
                                    'd-flex justify-content-between align-items-center'
                                  }
                                >
                                  <button
                                    onClick={() =>
                                      copyText(bankDetail.card_number)
                                    }
                                    className={'btn btn-sm'}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-clipboard"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                                      <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                                    </svg>
                                  </button>
                                  <h4 className={'m-0 ms-2'}>
                                    {bankDetail.card_number}
                                  </h4>
                                </div>
                                <h5
                                  className={'badge badge-primary mt-3 w-100'}
                                >
                                  شماره شبا
                                </h5>
                                <div
                                  className={
                                    'd-flex justify-content-between align-items-center'
                                  }
                                >
                                  <button
                                    onClick={() =>
                                      copyText(bankDetail.shaba_number)
                                    }
                                    className={'btn btn-sm'}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-clipboard"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                                      <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                                    </svg>
                                  </button>
                                  <h4 className={'m-0 ms-2'}>
                                    {bankDetail.shaba_number}
                                  </h4>
                                </div>
                                <h5
                                  className={'badge badge-primary mt-3 w-100'}
                                >
                                  مالک حساب
                                </h5>
                                <div
                                  className={
                                    'd-flex justify-content-between align-items-center'
                                  }
                                >
                                  <h4 className={'m-0 ms-2'}>
                                    {bankDetail.owner_name}
                                  </h4>
                                  <h4 className={'m-0'}>
                                    {bankDetail.bank_name}
                                  </h4>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <h5>
                                <span>آیا از پرداخت فاکتور به شماره</span>
                                <span className={'mx-1'}>
                                  {factorInfo.invoice_no}
                                </span>
                                <span>اطمینان دارید؟</span>
                              </h5>
                            </>
                          )}
                        </div>
                        {modalDetail.type === 2 && (
                          <div className={'modal-footer'}>
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() =>
                                setModalDetail({
                                  ...modalDetail,
                                  show: false
                                })
                              }
                            >
                              خیر
                            </button>
                            <button
                              type={'button'}
                              className={'btn btn-success'}
                              onClick={paymentFactor}
                            >
                              پرداخت
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div
                className="modal-backdrop fade show"
                onClick={() =>
                  setModalDetail({
                    ...modalDetail,
                    show: false
                  })
                }
              ></div>
            </>
          )}
        </>
      )}
      {
        <Alert
          alerts={alertStore.alert}
          close={alertStore.RemoveAlert}
          timeout={alert_timeout}
        />
      }
    </>
  );
};

export default FactorDetail;
